import useObserver from '../../hooks/page/useObserver';
import PageTemplate from '../../components/ui/PageTemplate';
import LeadMember from './LeadMember';
import Staff from './Staff';
import Advisors from './Advisors';

const Team = () => {
  useObserver('content-Team', 'content-Team-desktop');

  return (
    <PageTemplate id='Team'>
      {/* Mobile Layout */}
      <div
        id='content-Team'
        className='md:hidden w-full py-20 flex flex-col gap-6 relative max-w-[360px] mx-auto'
      >
        <div className='relative z-20 flex flex-col gap-10 px-4'>
          <div className='flex flex-col justify-start items-start w-full'>
            <h1 className='text-[20px] font-semibold text-[#FFFFFF]'>Team</h1>
          </div>
          <div className='flex flex-col gap-2'>
            <p className='text-base font-semibold text-[#ffffff]'>Lead Members</p>
            <div className='w-full'>
              <LeadMember />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <p className='text-base font-semibold text-[#FFFFFF]'>Staff</p>
            <div className='w-full'>
              <Staff />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <p className='text-base font-semibold text-[#FFFFFF]'>Advisors</p>
            <div className='w-full'>
              <Advisors />
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div
        id='content-Team-desktop'
        className='hidden md:flex w-full bg-cover bg-center bg-no-repeat flex-col py-36 md:gap-16 xl:gap-32 relative overflow-hidden'
        style={{ backgroundImage: "url('/redesign/BG_Resources.png')" }}
      >
        <div className='relative z-20 flex flex-col w-full xl:max-w-[1060px] md:max-w-[688px] mx-auto gap-6 md:gap-24 xl:gap-24'>
          <div className='flex flex-col justify-start items-start w-full'>
            <h1 className='xl:text-[28px] md:text-[30px] font-semibold text-[#FFFFFF]'>Team</h1>
          </div>
          <div className='flex flex-col gap-16'>
            <div className='flex flex-col gap-4'>
              <p className='md:text-[20px] font-semibold text-[#FFFFFF]'>
                Lead Members
              </p>
              <div className='w-fit flex justify-start'>
                <LeadMember />
              </div>
            </div>
            <div className='flex flex-col gap-4'>
              <p className='md:text-[20px] font-semibold text-[#FFFFFF]'>
                Staff
              </p>
              <div className='w-fit flex justify-start'>
                <Staff />
              </div>
            </div>
            <div className='flex flex-col gap-4'>
              <p className='md:text-[20px] font-semibold text-[#FFFFFF]'>
                Advisors
              </p>
              <div className='w-fit flex justify-start'>
                <Advisors />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Team;
